export const ACCOUNT_STATEMENT = "ACCOUNT_STATEMENT";
export const WITHDRAW_LIST = "WITHDRAW_LIST";
export const PLAYER_BANK_DETAILS = "PLAYER_BANK_DETAILS";
